import styled from 'styled-components'
import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useWithAuth } from '../../containers/App'
import { map, xor, includes } from 'lodash/fp'
import Modal from '../Modal'
import Button from '../../components/Button'
import Table from '../../components/Table'
import { SendMailModal } from './SendMailModal'
import withLoading from '../../utils/withLoading'
import { useNotifications } from '../Notifications'
// @ts-ignore @todo add apprioprate declaration file
import sendIcon from '../../images/sendIconRed.svg'
// @ts-ignore @todo add apprioprate declaration file
import downloadIcon from '../../images/downloadIcon.svg'
import Checkbox from '../../components/Checkbox'
import { normalizeSortState } from '../../components/Table/convertSortState'
import colors from '../../styles/colors'
import Search from '../../components/Search/index'
import { Hidden } from '../../styles/Shared'
import { Materials, OpenModalProps, ModalStateProps } from './utils'

const endpoint = '/report/rest/material/search'
const endpointRelatedToDiagnosis = '/report/rest/material/examination/search'
const PATIENT_ENDPOINT = '/diagnostic/rest/patient'

const PostDiagnosticModal = ({ onClose, isOpen, examinationId }) => {
  const id = location.pathname.substring(location.pathname.lastIndexOf('/') + 1)
  const [materials, setMaterials] = useState<Materials[]>()
  const [
    materialsRelatedToDiagnosis,
    setMaterialsRelatedToDiagnosis,
  ] = useState<Materials[]>()
  const [singularSend, setSingularSend] = useState<boolean>(false)
  const [singularDiagnostic, setSingularDiagnostic] = useState<string[]>(null)
  const [ready, setReady] = useState<boolean>(false)
  const [reFetch, setReFetch] = useState(true)
  const [relatedReady, setRelatedReady] = useState<boolean>(false)
  const withAuth = useWithAuth()
  const { notify } = useNotifications()
  const LoadingTable = withLoading(Table)
  const [modalState, setModalState] = useState<ModalStateProps>({
    recipients: [],
    materialFilenames: [],
  })
  const [openModal, setOpenModal] = useState<OpenModalProps>({ open: false })
  const [state, setState] = useState({
    meta: {
      limit: 10,
      page: 0,
      total: 0,
      sorts: [],
    },
    filters: { search: '' },
    filenames: [],
  })
  const [stateRelatedToDiagnosis, setStateRelatedToDiagnosis] = useState({
    meta: {
      limit: 10,
      page: 0,
      total: 0,
      sorts: [],
    },
    filters: {
      disability: null,
      examinationDate: null,
      patientDateOfBirth: null,
      examinationId: null,
    },
    filenames: [],
  })

  const onSortedChange = (sort) => {
    setState({ ...state, meta: { ...state.meta, sorts: sort } })
    setReFetch(true)
  }
  const onPageChange = (index) => {
    setState({ ...state, meta: { ...state.meta, page: index } })
    setReFetch(true)
  }

  const onSearchChange = (search) => {
    setState((prevState) => ({
      ...prevState,
      filters: { ...prevState.filters, search },
      meta: { ...prevState.meta, page: 0 },
    }))
    setReFetch(true)
  }

  const onSortedChangeRelatedToDiagnosis = (sort) => {
    setStateRelatedToDiagnosis({
      ...stateRelatedToDiagnosis,
      meta: { ...stateRelatedToDiagnosis.meta, sorts: sort },
    })
  }
  const onPageChangeRelatedToDiagnosis = (index) => {
    setStateRelatedToDiagnosis({
      ...stateRelatedToDiagnosis,
      meta: { ...stateRelatedToDiagnosis.meta, page: index },
    })
  }

  const fetchMaterials = async () => {
    setReady(false)
    const result = await withAuth(`${endpoint}`, {
      method: 'POST',
      payload: {
        filters: {
          ...state.filters,
        },

        meta: {
          ...state.meta,
          sorts: normalizeSortState(state.meta.sorts),
        },
      },
    })
    setReady(true)
    return result
  }

  const fetchData = async () => {
    try {
      const result = await fetchMaterials()
      const filenames = map('filename', result.models)
      setMaterials(result.models)
      setState({ ...state, meta: { ...result.meta }, filenames })
    } catch {
      notify('Nie udało się pobrać materialów postdiagnostycznych', 'error')
    }
  }
  

  useEffect(() => {
    setReFetch(false)
    fetchData()
  }, [reFetch === true])

  useEffect(() => {
    const fetchPetientsData = async () => {
      try {
        const result = await withAuth(`${PATIENT_ENDPOINT}/${id}`, {
          method: 'GET',
        })
        setStateRelatedToDiagnosis({
          meta: {
            limit: 10,
            page: 0,
            total: 0,
            sorts: [],
          },
          filters: {
            disability: result.model.disability,
            examinationDate: result.model.creationDate,
            patientDateOfBirth: result.model.person.dateOfBirth,
            examinationId: examinationId,
          },
          filenames: [],
        })
      } catch (e) {}
    }
    fetchPetientsData()
  }, [withAuth])

  const fetchMaterialsRelatedToDiagnosis = async () => {
    setRelatedReady(false)
    const result = await withAuth(`${endpointRelatedToDiagnosis}`, {
      method: 'POST',
      payload: {
        filters: {
          ...stateRelatedToDiagnosis.filters,
        },

        meta: {
          ...stateRelatedToDiagnosis.meta,
          sort: normalizeSortState(stateRelatedToDiagnosis.meta.sorts),
        },
      },
    })
    setRelatedReady(true)
    return result
  }

  const fetchRelatedToDiagnosis = async () => {
    try {
      const result = await fetchMaterialsRelatedToDiagnosis()
      const filenames = map('filename', result.models)
      setMaterialsRelatedToDiagnosis(result.models)
      setStateRelatedToDiagnosis({
        ...stateRelatedToDiagnosis,
        meta: { ...result.meta },
        filenames,
      })
    } catch {
      notify('Nie udało się pobrać materiałów związanych z diagnozą', 'error')
    }
  }

  useEffect(() => {
    if (
      stateRelatedToDiagnosis.filters.disability &&
      stateRelatedToDiagnosis.filters.examinationDate &&
      stateRelatedToDiagnosis.filters.patientDateOfBirth
    ) {
      fetchRelatedToDiagnosis()
    } else return
  }, [
    stateRelatedToDiagnosis.meta.sorts,
    stateRelatedToDiagnosis.filters,
    stateRelatedToDiagnosis.meta.page,
  ])

  const setItemSelection = (items) =>
    setModalState({
      recipients: [],
      materialFilenames: [...items],
    })
  const handleMailSending = useCallback(
    (vals, isSingular: boolean) => {
      const sendMail = async () => {
        const result = await withAuth(`/report/rest/material/send`, {
          method: 'POST',
          payload: {
            recipients: vals.recipients.split(','),
            materialFilenames: isSingular
              ? singularDiagnostic
              : modalState.materialFilenames,
          },
        })
        result
          ? notify('Zarejestrowano zlecenie wysyłki', 'success')
          : notify(
              'Nie udało zarejestrować zlecenia wysyłki, spróbuj ponownie',
              'error'
            )
        setModalState({
          recipients: [],
          materialFilenames: [],
        })
        setSingularDiagnostic(null)
        setOpenModal({ open: false })
      }
      sendMail()
    },
    [modalState, openModal, withAuth, notify]
  )

  const isAnyRowChecked: boolean = modalState.materialFilenames.length != 0

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closer={true}
      title={
        <span>
          <SendPositioner isHidden={isAnyRowChecked === false}>
            <span aria-live="polite">
              Wybrano {modalState.materialFilenames.length}
            </span>
            <Button
              postModal
              link={null}
              icon={sendIcon}
              color="white"
              label="Wyślij"
              marginLeft
              width="200px"
              onClick={() => {
                setOpenModal({ open: true })
                setSingularSend(false)
              }}
              altTag=""
              srText=""
            />
          </SendPositioner>

          <Title isHidden={isAnyRowChecked === true}>
            Materiały postdiagnostyczne
          </Title>
        </span>
      }
      postModal
    >
      <div>
        <SubTitle subFirst>Materiały powiązane</SubTitle>

        <LoadingTable
          noBorderBottom
          postModal
          borderTable
          onSortedChange={(s) => onSortedChangeRelatedToDiagnosis(s)}
          onPageChange={(index) => onPageChangeRelatedToDiagnosis(index)}
          page={stateRelatedToDiagnosis.meta.page}
          total={stateRelatedToDiagnosis.meta?.total}
          defaultPageSize={stateRelatedToDiagnosis.meta.limit}
          getLoadingProps={() => ({
            'aria-hidden': true,
            role: 'none',
          })}
          order={stateRelatedToDiagnosis.meta.sorts}
          ready={relatedReady}
          data={materialsRelatedToDiagnosis}
          getTheadTrProps={() => ({
            style: { display: 'flex', alignItems: 'center' },
          })}
          columns={[
            {
              Header: <Hidden>Akcja</Hidden>,
              Cell: ({ original }) => (
                <StyledCheckbox
                  hiddenLabel
                  label="Zaznacz materiał"
                  aria-label="Zaznacz materiał"
                  input={{
                    value: includes(
                      original.filename,
                      modalState.materialFilenames
                    ),
                    onChange: () =>
                      setItemSelection(
                        xor([original.filename], modalState.materialFilenames)
                      ),
                  }}
                />
              ),

              getProps: () => ({
                onClick: (e) => e.stopPropagation(),
              }),
            },
            {
              Header: <Hidden>Nazwa</Hidden>,
              id: 'displayedName',
              accessor: ({ displayedName }) => (
                <TooltipWrap>
                  <span>{displayedName}</span>
                  <Tooltip>
                    <div className="arrow-box">{displayedName}</div>
                  </Tooltip>
                </TooltipWrap>
              ),
            },

            {
              Header: <Hidden>Rozmiar</Hidden>,
              id: 'size',
              accessor: ({ size }) => size,
              getProps: () => ({
                role: undefined,
              }),
            },
            {
              Header: <Hidden>Akcja</Hidden>,
              id: 'action1',
              Cell: ({ original }) => (
                <IconButton
                  type="button"
                  onClick={() => {
                    setOpenModal({ open: true })
                    setSingularSend(true)
                    setSingularDiagnostic(
                      xor([original.filename], singularDiagnostic)
                    )
                  }}
                >
                  Wyślij
                  <Img alt="" src={sendIcon} aria-hidden="true" />
                </IconButton>
              ),
            },
            {
              Header: <Hidden>Akcja</Hidden>,
              id: 'action2',
              Cell: ({ original }) => (
                <StyledHyperlink
                  download
                  href={`../../doc/${original.filename.replaceAll(' ', '%20')}`}
                >
                  Pobierz
                  <Img alt="" src={downloadIcon} aria-hidden="true" />
                </StyledHyperlink>
              ),
            },
          ]}
        />
      </div>

      <div>
        <Wrapper>
          <SubTitle>Wszystkie materiały</SubTitle>
          <label>
            <Search
              postModal
              ariaLabel={
                state.filters.search
                  ? `Szukaj liczba znalezionych wyników: ${
                      materials != null ? materials.length : 0
                    }`
                  : 'Szukaj'
              }
              width={450}
              placeholder="Szukaj"
              input={{ onChange: onSearchChange, value: '' }}
            />
          </label>
        </Wrapper>

        <LoadingTable
          noBorderBottom
          postModal
          borderTable
          page={state.meta.page}
          getLoadingProps={() => ({
            'aria-hidden': true,
            role: 'none',
          })}
          total={state.meta?.total}
          order={state.meta.sorts}
          ready={ready}
          data={materials}
          defaultPageSize={state.meta.limit}
          onSortedChange={(s) => onSortedChange(s)}
          onPageChange={(index) => onPageChange(index)}
          columns={[
            {
              Header: <Hidden>Akcja</Hidden>,
              Cell: ({ original }) => (
                <StyledCheckbox
                  hiddenLabel
                  label="Zaznacz materiał"
                  aria-label="Zaznacz materiał"
                  input={{
                    value: includes(
                      original.filename,
                      modalState.materialFilenames
                    ),
                    onChange: () =>
                      setItemSelection(
                        xor([original.filename], modalState.materialFilenames)
                      ),
                  }}
                />
              ),

              getProps: () => ({
                onClick: (e) => e.stopPropagation(),
              }),
            },
            {
              Header: <Hidden>Nazwa</Hidden>,
              id: 'displayedName',
              accessor: ({ displayedName }) => (
                <TooltipWrap>
                  <span>{displayedName}</span>
                  <Tooltip>
                    <div className="arrow-box">{displayedName}</div>
                  </Tooltip>
                </TooltipWrap>
              ),
            },

            {
              Header: <Hidden>Rozmiar</Hidden>,
              id: 'size',
              accessor: ({ size }) => size,
              getProps: () => ({
                role: undefined,
              }),
            },
            {
              Header: <Hidden>Akcja</Hidden>,
              id: 'action1',
              Cell: ({ original }) => (
                <IconButton
                  type="button"
                  onClick={() => {
                    setOpenModal({ open: true })
                    setSingularSend(true)
                    setSingularDiagnostic(
                      xor([original.filename], singularDiagnostic)
                    )
                  }}
                >
                  Wyślij
                  <Img alt="" src={sendIcon} aria-hidden="true" />
                </IconButton>
              ),
            },
            {
              Header: <Hidden>Akcja</Hidden>,
              id: 'action2',
              Cell: ({ original }) => (
                <StyledHyperlink
                  download
                  href={`../../doc/${original.filename.replaceAll(' ', '%20')}`}
                >
                  Pobierz
                  <Img alt="" src={downloadIcon} aria-hidden="true" />
                </StyledHyperlink>
              ),
            },
          ]}
        />
      </div>

      {openModal.open && (
        <SendMailModal
          isOpen={openModal.open}
          onClose={() => {
            setOpenModal({ open: false })
            setModalState({
              recipients: [],
              materialFilenames: [],
            })
            setSingularDiagnostic(null)
          }}
          onSubmit={(vals) => {
            handleMailSending(vals, singularSend)
          }}
        />
      )}
    </Modal>
  )
}

const Title = styled.span`
  font-size: 1.5rem;
  font-weight: 400;
  margin-left: 0.3rem;
  ${({ isHidden }) => isHidden && 'display: none'};
`
const SubTitle = styled.h3`
  font-size: 0.7rem;
  text-transform: uppercase;
  ${(props) =>
    props.subFirst ? `margin: 0 0 1rem .3rem` : ` margin: .3rem 0 0 .3rem`}
`
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 3rem 0 1rem;
  justify-content: space-between;
`

const Img = styled.img`
  margin-bottom: 0;
`

const IconButton = styled.button`
  display: flex;
  margin-right: 25px;
  color: ${colors.monza};
  background: transparent;
  border: none;
  align-items: center;
  cursor: ${(props) => !props.disabled && `pointer;`};
  height: auto;
  border-radius: 5px;
  > * {
    padding: 0 0 0 3px;
  }
  ${Img} {
    opacity: ${(props) => props.disabled && `50%`};
  }
`
const StyledCheckbox = styled(Checkbox)`
  margin-top: 15px;
  label {
    // bez ponizszych z-indexow nie widac focusa na input przy przechodzeniu Tab
    &:before {
      z-index: 2;
    }
    &:after {
      z-index: 2;
    }
    input {
      z-index: 1;
    }
  }
`

const SendPositioner = styled.span`
  display: flex;
  align-items: center;
  display: block;
  ${({ isHidden }) => isHidden && 'display: none'};
  h2 {
    margin-right: 10px;
    margin-top: 8px;
    color: ${colors.monza};
    font-family: Raleway;
    font-weight: 200;
  }
`
const StyledHyperlink = styled.a`
  display: flex;
  margin-right: 25px;
  color: ${colors.monza};
  border: none;
  text-decoration: none;
  align-items: center;
  cursor: ${(props) => !props.disabled && `pointer;`};
  height: auto;
  border-radius: 5px;
  > * {
    padding: 0 0 0 3px;
  }
  ${Img} {
    opacity: ${(props) => props.disabled && `50%`};
  }
  a {
  }
`
const Tooltip = styled.div`
  display: none;
`
const TooltipWrap = styled.div`
  &:hover ${Tooltip} {
    z-index: 100;
    margin-top: -5rem;
    position: absolute;
    display: block;
    color: white;
    background: #454545;
    border-radius: 4px;
    padding: 4px 12px;
    white-space: normal;
    min-width: 350px;
    line-height: 24px;
    min-height: 30px;

    .arrow-box:after {
      position: absolute;
      border: 8px solid transparent;
      border-top-color: #454545;
      content: ' ';
      height: 0;
      width: 0;
      top: 100%;
      left: 20px;
    }
  }
`
export default PostDiagnosticModal
